/* Noble Outfitters: Fit option filters the Size buttons.

   Products that sell two size ranges in one listing have a "Fit" option
   (Toddler / Kids, Regular / Plus) between Color and Size. Only the sizes
   that exist for the selected Fit should be shown: Toddler shows 2T-5T,
   Kids shows S/M/L (or 6-12), Regular shows XS-XXL, Plus shows 1X-3X.

   snippets/variant-button.liquid tags every Size button with the Fit values
   it exists in (data-fits="|Toddler|") and hides the non-matching ones on
   page load. This script re-filters them whenever the Fit changes. If the
   currently selected size gets hidden, it selects the first visible size so
   the product form always points at a real variant.

   Loaded by variant-button.liquid only on products that have a Fit option.
   It may be included more than once (e.g. product page + quick shop), so it
   guards against running twice. */
(function () {
  if (window.nobleFitFilterLoaded) return;
  window.nobleFitFilterLoaded = true;

  var FIT_INPUT = 'fieldset[data-handle="fit"] input[type="radio"]';

  function syncFit(fitInput) {
    if (!fitInput) return;
    var formId = fitInput.getAttribute('form');
    var fitKey = '|' + fitInput.value + '|';
    var sizeSets = document.querySelectorAll('fieldset[data-fit-filtered][data-form="' + formId + '"]');

    sizeSets.forEach(function (sizeSet) {
      var firstVisible = null;
      var selectedHidden = false;

      sizeSet.querySelectorAll('.variant-input[data-fits]').forEach(function (button) {
        var show = button.getAttribute('data-fits').indexOf(fitKey) !== -1;
        var input = button.querySelector('input');
        button.style.display = show ? '' : 'none';
        if (show && !firstVisible) firstVisible = input;
        if (!show && input && input.checked) selectedHidden = true;
      });

      // The selected size isn't offered in this Fit: switch to the first one
      // that is. Dispatching "change" lets the theme update the variant,
      // price, images and URL as if the shopper had clicked it.
      if (selectedHidden && firstVisible) {
        firstVisible.checked = true;
        firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function syncAll() {
    document.querySelectorAll(FIT_INPUT + ':checked').forEach(syncFit);
  }

  document.addEventListener('change', function (evt) {
    var target = evt.target;
    if (target && target.matches && target.matches(FIT_INPUT)) syncFit(target);
  });

  // The theme's Dynamic Variants can change the selected Fit on its own
  // (e.g. jumping to the closest in-stock variant), so re-check after every
  // variant change.
  document.addEventListener('variant:change', syncAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
